export default {
  language_selector: {
    label: 'Choose a language',
  },
  nav_items: {
    home: 'Home',
    menu: 'Menu',
    locations: 'Locations',
    store_info: 'Store Info',
    rewards: 'Rewards',
  },
};
